import React from "react";
import { useFeatureFlag } from "../../../../launch-darkly";
import { LottiePlayer } from "../../../lottie-player/LottiePlayer";
import { Header, SlideLayout, Text } from "../../shared-components";
import aiSchedularAnimation from "./assets/ai-scheduler-animation.lottie";
import aiSummary from "./assets/ai-summary.svg";

const Image = () => {
  return <img src={aiSummary} className="cw-w-full md:cw-h-[475px] cw-mt-3" />;
};

export const AISchedulerSlide = () => {
  const [isOnAIOnboarding] = useFeatureFlag("rollout-ai-onboarding");

  if (isOnAIOnboarding) {
    return (
      <SlideLayout>
        <Header>Meet your calendar assistant</Header>
        <Text>
          Clockwise allows you to delegate calendar management with intelligent scheduling and
          automation.
        </Text>
        <Image />
      </SlideLayout>
    );
  }

  return (
    <SlideLayout>
      <Header>Say hello to easier scheduling</Header>
      <Text>
        With Clockwise AI Scheduler, you can schedule an impossible meeting or clear an entire day
        with a single chat.
      </Text>
      <LottiePlayer
        className="cw-mt-6 md:cw-mt-0 cw-border cw-border-solid cw-rounded-[14px] cw-border-default-pressed"
        autoplay
        loop
        src={aiSchedularAnimation}
      />
    </SlideLayout>
  );
};
